import { Controller } from "@hotwired/stimulus"
import { parseClrText } from "../shared/parse_clr"

export default class extends Controller {
  static targets = ["file", "message"]

  declare readonly fileTarget: HTMLInputElement
  declare readonly messageTarget: HTMLElement
  declare readonly hasMessageTarget: boolean

  importFile() {
    const file = this.fileTarget.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => {
      try {
        const entries = parseClrText(String(reader.result ?? ""))
        if (entries.length === 0) {
          throw new Error("No valid entries found in the .clr file.")
        }

        this.dispatch("imported", { detail: { entries, fileName: file.name } })
      } catch (error) {
        const message = error instanceof Error ? error.message : "Could not read the .clr file."
        this.setMessage(message, true)
      } finally {
        this.fileTarget.value = ""
      }
    }
    reader.onerror = () => {
      this.setMessage("Could not read the selected file.", true)
      this.fileTarget.value = ""
    }
    reader.readAsText(file)
  }

  setMessage(message: string, isError = false) {
    if (!this.hasMessageTarget) return
    this.messageTarget.textContent = message
    this.messageTarget.classList.toggle("text-danger", isError)
    this.messageTarget.classList.toggle("text-muted", !isError)
  }
}
